// ** React Imports
import { useState, Fragment } from "react";

// ** Next Import
import { useRouter } from "next/router";

// ** MUI Imports
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";

// ** Icon Imports
import Icon from "src/@core/components/icon";

// ** Context
import { useAuth } from "src/hooks/useAuth";
import { Button, IconButton } from "@mui/material";

// ** Styled Components
const BadgeContentSpan = styled("span")(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: theme.palette.success.main,
  boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
}));

const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  "&:hover .MuiBox-root, &:hover .MuiBox-root svg": {
    color: theme.palette.primary.main,
  },
}));

const UserDropdown = (props) => {
  // ** Props
  const { settings } = props;

  // ** States
  const [anchorEl, setAnchorEl] = useState(null);

  // ** Hooks
  const router = useRouter();
  const { logout } = useAuth();

  // ** Vars
  const { direction } = settings;

  const handleDropdownOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = (url) => {
    if (url) {
      router.push(url);
    }
    setAnchorEl(null);
  };

  const styles = {
    px: 4,
    py: 1.75,
    width: "100%",
    display: "flex",
    alignItems: "center",
    color: "text.primary",
    textDecoration: "none",
    "& svg": {
      mr: 2.5,
      color: "text.primary",
    },
  };

  const handleLogout = () => {
    logout(true);
    handleDropdownClose();
  };

  return (
    <Fragment>
      {/* <IconButton color='inherit' aria-haspopup='true' onClick={handleDropdownOpen} aria-controls='customized-menu'>
        <Typography color={'white'}>حساب کاربری</Typography>
      </IconButton> */}

      {/* <Button variant='text' size='medium' color='primary' onClick={handleDropdownOpen}>
        حساب کاربری
      </Button> */}
      <Badge
        overlap="circular"
        onClick={handleDropdownOpen}
        sx={{ ml: 2, cursor: "pointer" }}
        // badgeContent={<BadgeContentSpan />}
        // anchorOrigin={{
        //   vertical: 'bottom',
        //   horizontal: 'right'
        // }}
      >
        <Avatar
          alt="John Doe"
          onClick={handleDropdownOpen}
          sx={{ width: 40, height: 40 }}
          // src='/images/avatars/1.png'
        />
      </Badge>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleDropdownClose()}
        sx={{ "& .MuiMenu-paper": { width: 230, mt: 4.5 } }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: direction === "ltr" ? "right" : "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: direction === "ltr" ? "right" : "left",
        }}
      >
        <MenuItemStyled
          sx={{ p: 0 }}
          onClick={() => handleDropdownClose("/profile")}
        >
          <Box sx={styles}>
            <Icon icon="tabler:user-check" />
            حساب کاربری
          </Box>
        </MenuItemStyled>
        <MenuItemStyled
          sx={{ p: 0 }}
          onClick={() => handleDropdownClose("/orders")}
        >
          <Box sx={styles}>
            <Icon icon="tabler:currency-dollar" />
            سفارشات
          </Box>
        </MenuItemStyled>
        <MenuItemStyled
          sx={{ p: 0 }}
          onClick={() => handleDropdownClose("/tickets")}
        >
          <Box sx={styles}>
            <Icon icon="streamline:customer-support-1" />
            تیکت ها
          </Box>
        </MenuItemStyled>
        <Divider sx={{ my: (theme) => `${theme.spacing(2)} !important` }} />
        <MenuItemStyled
          onClick={handleLogout}
          sx={{ py: 2, "& svg": { mr: 2, fontSize: "1.375rem" } }}
        >
          <Icon icon="tabler:logout" />
          خروج
        </MenuItemStyled>
      </Menu>
    </Fragment>
  );
};

export default UserDropdown;
